import WinRateInfoForm from "./winRateInfoForm.container";

export default WinRateInfoForm;
